module.exports = __webpack_public_path__ + "images/b6eba0665a605f64114e406e43cab58c.png";